import React from 'react';
import ReactDOM from 'react-dom';
import './css/spectre.min.css';
import './css/spectre-icons.min.css';
import './css/spectre-exp.min.css';
import App from './App';
import {Provider} from 'mobx-react'
import {uiState} from './stateClass/UIState'
import {otherState} from './stateClass/OtherState'
import {appState} from './stateClass/AppState'
import {inputState} from './stateClass/InputState'

const states = {otherState,uiState,appState,inputState}
ReactDOM.render(
  <Provider {...states}>
    <App />
  </Provider>
  , document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js